import { render, staticRenderFns } from "./Emotions.vue?vue&type=template&id=45631084&scoped=true"
import script from "./Emotions.vue?vue&type=script&lang=js"
export * from "./Emotions.vue?vue&type=script&lang=js"
import style0 from "./Emotions.vue?vue&type=style&index=0&id=45631084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45631084",
  null
  
)

export default component.exports